<template>

    <div class="registration-step-container">
        <div id="home"></div>

        <section class="common">
        <div id="top"></div>

            <div v-if="pageType == 0 || pageType == 3" class="card_registration-step">
                <swiper class="swiper-container"
                    :pagination='{
                        type: "progressbar"
                    }'
                    :navigation='{
                        nextEl: ".js-swiper-next",
                        prevEl: ".js-swiper-prev"
                    } '
                    :noSwipingSelector="'.swiper-slide-inner'"
                    :effect="'fade'"
                    :slides-per-view="1"
                    :space-between="0"
                    :speed="1000"
                >

                    <swiper-slide v-if="res">
                        <MembershipRegistrationShopStep404 v-bind:response="res" />
                    </swiper-slide>

                    <swiper-slide>
                        <MembershipRegistrationShopStep9 />
                    </swiper-slide>


                </swiper>
            </div>

            <!--確認画面-->
            <MembershipRegistrationShopStep10 v-bind:brand="brand"
                                                v-bind:show_preview="show_preview"
                                                v-on:openCropperModal="openCropper"
                                                v-on:closeCropperModal="closeCropper"
                                                v-on:toast="showToast($event)"/>

            <div v-if="showPriceZone" class="card_registration-step">
                <swiper class="swiper-container"
                    :pagination='{
                        "type": "progressbar"
                    }'
                    :navigation='{
                        "nextEl": ".js-swiper-next",
                        "prevEl": ".js-swiper-prev"
                    } '
                    :noSwipingSelector="'.swiper-slide-inner'"
                    :effect="'fade'"
                    :slides-per-view="1"
                    :space-between="0"
                    :speed="1000"
                >
                    <swiper-slide>
                        <MembershipRegistrationStep11PriceZone0  v-on:swiperBackPriceZone="backPriceZone" />
                    </swiper-slide>

                    <swiper-slide>
                        <MembershipRegistrationStep11PriceZone1 />
                    </swiper-slide>

                    <swiper-slide>
                        <MembershipRegistrationStep11PriceZone2 />
                    </swiper-slide>

                    <swiper-slide>
                        <MembershipRegistrationStep11PriceZone3 v-on:showConfirm="showConfirmPriceZone"/>
                    </swiper-slide>

                </swiper>
            </div>

            <!-- 管理画面での編集の場合 -->
            <div class="card_registration-step examination-completion" v-if="pageType == 1">
                <div class="card-inner">
                    <div class="question-wrap">
                        <h3><span>保存が完了しました</span></h3>
                        <div class="svg-icon-wrap">
                            <SvgIconCheck />
                        </div>
                        <div class="btn_link-wrap _w100" style="margin-top:2rem;">
                            <button type="button" class="btn_link" v-on:click="backList()"><span>一覧へ戻る</span></button>
                            <div class="bg-element"></div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="card_registration-step examination-completion" v-if="show_confirm_price_zone && (pageType == 0 || pageType == 3)">
                <div class="card-inner">
                    <div class="question-wrap" v-if="!showDemo">
                        <h3><span>審査登録が完了しました</span></h3>
                        <div class="svg-icon-wrap">
                            <SvgIconCheck />
                        </div>
                        <p>運営審査が通りましたらメールにてご連絡させていただきます。</p>
                        <div class="btn_link-wrap _w100" style="margin-top:2rem;">
                            <button v-if="pageType == 0" type="button" class="btn_link" v-on:click="getTOP()"><span>TOP</span></button>
                            <button v-if="pageType == 3" type="button" class="btn_link" v-on:click="backList()"><span>一覧へ戻る</span></button>
                            <div class="bg-element"></div>
                        </div>
                    </div>
                    <div class="question-wrap" v-if="showDemo">
                        <h3><span>保存が完了しました</span></h3>
                        <div class="svg-icon-wrap">
                            <SvgIconCheck />
                        </div>
                        <div class="btn_link-wrap _w100" style="margin-top:2rem;">
                            <button v-if="pageType == 0" type="button" class="btn_link" v-on:click="getTOP()"><span>TOP</span></button>
                            <button v-if="pageType == 3" type="button" class="btn_link" v-on:click="backList()"><span>一覧へ戻る</span></button>
                            <div class="bg-element"></div>
                        </div>
                    </div>

                </div>
            </div>
        </section>

        <!--BackGround-->
        <div class="md_swiper-bg _fixed">
            <swiper
                :effect="'fade'"
                :slides-per-view="1"
                :space-between="0"
                :speed="3000"
                :autoplay='{
                    "delay": 5000,
                    "disableOnInteraction": false
                }'
            >
                <swiper-slide>
                    <img src="/img/registration/bg1.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="https://source.unsplash.com/1280x800/?fashion" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="https://source.unsplash.com/1280x800/?Sweets" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="https://source.unsplash.com/1280x800/?Store,white" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="https://source.unsplash.com/1280x800/?Store,colorful" alt="">
                </swiper-slide>
            </swiper>
        </div>

        <!----------------------------------------------
            Toast
        ------------------------------------------------->
        <Toast v-bind:toastFor="toastFor"/>

        <!----------------------------------------------
            Examination
        ------------------------------------------------->
        <!--Preview-->
        <div v-if="pageType != 2 && previewBtn" class="btn_examination-wrap _preview">
            <button type="button" class="btn_common _square" v-on:click="previewIn()">
                <div class="md_svg-icon">
                    <SvgIconCheck />
                </div>
                <span>プレビューを確認する</span>
                <div class="chevron"></div>
            </button>
        </div>

        <!--この内容で審査する-->
        <div v-if="pageType != 2" class="btn_examination-wrap _next">
            <button type="button" class="md_icon-btn" v-on:click="previewBack()">
                <div class="inner"><SvgIconBack /></div>
            </button>
            <button type="button" class="btn_common _square" v-on:click="examinationIn()">
                <div class="md_svg-icon">
                    <SvgIconCheck />
                </div>
                <span v-if="(pageType == 0 || pageType == 3) && !showShowRoom">価値評価判定ページに進む</span>
                <span v-if="pageType == 1 || showShowRoom">この内容で保存する</span>
                <div class="chevron"></div>
            </button>
        </div>

        <!--PreviewLabel-->
        <div v-if="pageType != 2" class="preview-label-wrap"><span>プレビュー表示中</span></div>

    </div>
    <AlertModal
        v-if="showAlertModal"
        @close="closeAlertModal"
        :title="alert_modal_title"
        :message="alert_modal_message"
        :mode="alert_modal_mode"
    />
    <RegisterPromotionModal></RegisterPromotionModal>
</template>


<script>
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'
    import AlertModal from '@/components/EndUser/ComponentList/AlertModal'
    import commonMixins from '@/common/utility.js'

    //Swiper.js
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import 'swiper/css';

    //Swiper.js - css
    import "swiper/css/pagination"
    import "swiper/css/navigation"
    import 'swiper/css/effect-fade';

    //SwiperModules
    import SwiperCore, {
        Autoplay,
        EffectFade,
        Pagination,
        Navigation
    } from 'swiper';
    SwiperCore.use([
        Autoplay,
        EffectFade,
        Pagination,
        Navigation
    ]);

    //Common
    import EndUserLayout from '@/Layouts/EndUserLayout'

    //Svg
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'

    //Step
    import MembershipRegistrationShopStep1 from '@/components/EndUser/MembershipRegistrationShopStep/Step1'
    import MembershipRegistrationShopStep2 from '@/components/EndUser/MembershipRegistrationShopStep/Step2'
    import MembershipRegistrationShopStep2A from '@/components/EndUser/MembershipRegistrationShopStep/Step2A'
    import MembershipRegistrationShopStep3 from '@/components/EndUser/MembershipRegistrationShopStep/Step3'
    import MembershipRegistrationShopStep4 from '@/components/EndUser/MembershipRegistrationShopStep/Step4'
    import MembershipRegistrationShopStep5 from '@/components/EndUser/MembershipRegistrationShopStep/Step5'
    import MembershipRegistrationShopStep6 from '@/components/EndUser/MembershipRegistrationShopStep/Step6'
    import MembershipRegistrationShopStep7 from '@/components/EndUser/MembershipRegistrationShopStep/Step7'
    import MembershipRegistrationShopStep8 from '@/components/EndUser/MembershipRegistrationShopStep/Step8'
    import MembershipRegistrationShopStep8Cropper from '@/components/EndUser/MembershipRegistrationShopStep/Step8Cropper'
    import MembershipRegistrationShopStep9 from '@/components/EndUser/MembershipRegistrationShopStep/Step9'
    import MembershipRegistrationShopStep10 from '@/components/EndUser/MembershipRegistrationShopStep/Step10'
    import MembershipRegistrationStep11PriceZone0 from '@/components/EndUser/MembershipRegistrationShopStep/Step11PriceZone0.vue'
    import MembershipRegistrationStep11PriceZone1 from '@/components/EndUser/MembershipRegistrationShopStep/Step11PriceZone1.vue'
    import MembershipRegistrationStep11PriceZone2 from '@/components/EndUser/MembershipRegistrationShopStep/Step11PriceZone2.vue'
    import MembershipRegistrationStep11PriceZone3 from '@/components/EndUser/MembershipRegistrationShopStep/Step11PriceZone3.vue'
    import MembershipRegistrationShopStep404 from '@/components/EndUser/MembershipRegistrationShopStep/Step404'
    import RegisterPromotionModal from '../../components/EndUser/RegisterPromotionModal';

    //Toast
    import Toast from '@/components/EndUser/PartsToast'
    import likeMixins from '@/common/like.js'

    export default {
        //Common
        mixins: [likeMixins, commonMixins],
        layout: EndUserLayout,
        components: {
            //Swiper.js
            Swiper,
            SwiperSlide,
            //Svg
            SvgIconCheck,
            SvgIconBack,
            //Step
            MembershipRegistrationShopStep1,
            MembershipRegistrationShopStep2,
            MembershipRegistrationShopStep2A,
            MembershipRegistrationShopStep3,
            MembershipRegistrationShopStep4,
            MembershipRegistrationShopStep5,
            MembershipRegistrationShopStep6,
            MembershipRegistrationShopStep7,
            MembershipRegistrationShopStep8,
            MembershipRegistrationShopStep8Cropper,
            MembershipRegistrationShopStep9,
            MembershipRegistrationShopStep10,
            MembershipRegistrationStep11PriceZone0,
            MembershipRegistrationStep11PriceZone1,
            MembershipRegistrationStep11PriceZone2,
            MembershipRegistrationStep11PriceZone3,
            MembershipRegistrationShopStep404,

            //Step
            Toast,

            "AlertModal": AlertModal,
            RegisterPromotionModal,
        },
        data() {
            return {
                toastIsOpen: false,
                toastFor: '',

                showPriceZone: false,
                show_confirm_price_zone: false,
                previewBtn: true,
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: '',
                show_preview: false,
            };
        },
        props: {
            res: Object,
            signup_token: Object,
            brand: Object,
            shop: Object,
            shops: Object,
            brands: Object,
            showrooms: Object,
            result: Array,
            like: Array,
            user: Object,
            shopUserPlan: Number,
            subscription_count: Object,
            isDemo: Boolean,
        },
        methods: {
            ////////////////////////////////////
            //会員登録画面の確認画面表示
            ////////////////////////////////////
            confirmIn: function () {
                //Swiperをフェードアウト
                $('.swiper-container').addClass('_hidden');
                setTimeout(() => {
                    //Swiperをdisplay:none;
                    $('.swiper-container').addClass('_none');
                }, 200);
                setTimeout(() => {
                    //確認画面のdisplay:none;を解除
                    $('.dply_detail-page').addClass('_block');
                }, 200);
                setTimeout(() => {
                    //確認画面をフェードイン
                    $('.dply_detail-page').addClass('_show');
                    //審査するボタンを表示
                    $('.btn_examination-wrap._preview').addClass('_show');
                }, 250);
            },
            ////////////////////////////////////
            //審査するボタンをクリック
            ////////////////////////////////////
            examinationIn: function () {
                //Swiperをフェードアウト
                if ((this.pageType == 0 || this.pageType == 3) && !this.showShowRoom) {
                    //初回登録
                    $('.btn_examination-wrap').removeClass('_show');
                    $('.dply_detail-page').removeClass('_show');
                    $('.preview-label-wrap').removeClass('_show');
                    setTimeout(() => {
                        $('.dply_detail-page').removeClass('_block');
                        $('.examination-completion').addClass('_block');
                    }, 800);
                    setTimeout(() => {
                        $('.examination-completion').addClass('_show');
                    }, 850);

                    // 価値評価のSwiperを表示
                    this.showPriceZone = true;

                } else if (this.pageType == 1 || this.showShowRoom) {
                    // 管理画面での編集
                    var id = '';
                    var type = '';
                    var demo = false;
                    var url = location.pathname;
                    if (this.brand || this.shop) {
                        if (url.indexOf( 'brand' ) != -1) {
                            id = this.brand.id;
                        } else if (url.indexOf( 'shop' ) != -1) {
                            id = this.shop.id;
                        } else if (url.indexOf( 'showroom' ) != -1) {
                            id = this.brand.id;
                        }
                    }
                    if (url.indexOf( 'brand' ) != -1) {
                        type = 1;
                    } else if (url.indexOf( 'shop' ) != -1) {
                        type = 0;
                    } else if (url.indexOf( 'showroom' ) != -1) {
                        type = 2;
                    }

                    if (url.indexOf( '/demo' ) != -1) {
                        demo = true;
                    }

                    const form = reactive({
                        id: id,
                        type: type,
                        demo: demo,
                        form: this.$store.state.register.form,
                    });
                    Inertia.post(route('registration.examination'), form, {
                        preserveScroll: true,
                        onError: (errors) => {
                            this.openAlertModal('error', 'エラー', errors.name); // 確認済み
                        },
                        onSuccess: visit => {
                            console.log("register1");
                            this.show_confirm_price_zone = true;
                            $('.btn_examination-wrap').removeClass('_show');
                            $('.dply_detail-page').removeClass('_show');
                            $('.preview-label-wrap').removeClass('_show');
                            setTimeout(() => {
                                $('.dply_detail-page').removeClass('_block');
                                $('.examination-completion').addClass('_block');
                            }, 800);
                            setTimeout(() => {
                                $('.examination-completion').addClass('_show');
                            }, 850);
                        },
                    })
                }
            },

            ////////////////////////////////////
            //審査プレビューをクリック
            ////////////////////////////////////
            previewIn: function () {
                // validate
                let validate = true;
                if (this.pageType != 2 && this.previewBtn) {
                    // name
                    if (!this.$store.state.register.form.name) {
                        this.$store.state.register.errors.name = true;
                        validate = false;
                    } else {
                        this.$store.state.register.errors.name = false;
                    }

                    // phonetic
                    if (!this.$store.state.register.form.phonetic) {
                        this.$store.state.register.errors.phonetic = true;
                        validate = false;
                    } else {
                        this.$store.state.register.errors.phonetic = false;
                    }

                    // main_image
                    if (this.$store.state.register.form.main_images[1] == '/img/no-image.svg' || this.$store.state.register.form.main_images[2] == '/img/no-image.svg') {
                        this.$store.state.register.errors.main_images = true;
                        validate = false;
                    } else {
                        this.$store.state.register.errors.main_images = false;
                    }

                    // concept
                    if (!this.$store.state.register.form.concept||this.$store.state.register.form.concept.length > 250) {
                        this.$store.state.register.errors.concept = true;
                        validate = false;
                    } else {
                        this.$store.state.register.errors.concept = false;
                    }

                    // category
                    let item_lv2 = [];
                    var step_categoriyLv2s = this.$store.state.register.form.categoriyLv2;
                    var step_categoriyLv3s = this.$store.state.register.form.categoriyLv3;

                    step_categoriyLv2s.forEach(function(step_categoriyLv2, step_categoriyLv2_index){
                        // アパレルのその他のみ第三階層がないので表示
                        if (step_categoriyLv2.id == 8) {
                            item_lv2.push(step_categoriyLv2)
                        }
                        if (step_categoriyLv2.first_category_id == 1){
                            step_categoriyLv3s.forEach(function(categoriyLv3, categoriyLv3_index){
                                if (step_categoriyLv2.id == categoriyLv3.second_category_id) {
                                    item_lv2.push(step_categoriyLv2)
                                }
                            });
                        } else {
                            item_lv2.push(step_categoriyLv2)
                        }
                    });
                    // 重複をなくす
                    const removeDuplicateValues = ([...array]) => {
                        return array.filter((value, index, self) => self.indexOf(value) === index);
                    }
                    item_lv2 = removeDuplicateValues(item_lv2);

                    let item_lv3 = this.$store.state.register.form.categoriyLv3;
                    if (item_lv2.length != 0 || item_lv3.length != 0) {
                        this.$store.state.register.errors.category = false;
                    } else {
                        this.$store.state.register.errors.category = true;
                        validate = false;
                    }

                    // target_min
                    if (this.$store.state.register.form.target_min == null) {
                        this.$store.state.register.errors.target_min = true;
                        validate = false;
                    } else {
                        this.$store.state.register.errors.target_min = false;
                    }

                    // target_max
                    if (!this.$store.state.register.form.target_max) {
                        this.$store.state.register.errors.target_max = true;
                        validate = false;
                    } else {
                        this.$store.state.register.errors.target_max = false;
                    }

                    // web_url
                    if (!this.$store.state.register.form.web_url) {
                        this.$store.state.register.errors.web_url = true;
                        validate = false;
                    } else {
                        this.$store.state.register.errors.web_url = false;
                    }

                    // net_shop
                    if (this.$store.state.register.form.net_shop == null) {
                        this.$store.state.register.errors.net_shop = true;
                        validate = false;
                    } else {
                        this.$store.state.register.errors.net_shop = false;
                    }

                    // ショップではない場合
                    var url = location.pathname;
                    if (url.indexOf( 'brand' ) != -1) {
                        // price_min
                        if (!this.$store.state.register.form.price_min) {
                            this.$store.state.register.errors.price_min = true;
                            validate = false;
                        } else {
                            this.$store.state.register.errors.price_min = false;
                        }

                        // price_max
                        if (!this.$store.state.register.form.price_max) {
                            this.$store.state.register.errors.price_max = true;
                            validate = false;
                        } else {
                            this.$store.state.register.errors.price_max = false;
                        }
                        // base
                        if (!this.$store.state.register.form.base) {
                            this.$store.state.register.errors.base = true;
                            validate = false;
                        } else {
                            this.$store.state.register.errors.base = false;
                        }
                        // // mail
                        // if (!this.$store.state.register.form.mail) {
                        //     // 入力していない場合
                        //     this.$store.state.register.errors.mail_required = true;
                        //     validate = false;
                        // } else {
                        //     const reg_mail = new RegExp(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+$/);
                        //     const val_mail = reg_mail.test(this.$store.state.register.form.mail);
                        //     if (!val_mail) {
                        //         // メールを入力していない場合
                        //         this.$store.state.register.errors.mail_required = false;
                        //         this.$store.state.register.errors.mail_error = true;
                        //         validate = false;
                        //     } else {
                        //         // OK
                        //         this.$store.state.register.errors.mail_required = false;
                        //         this.$store.state.register.errors.mail_error = false;
                        //     }
                        // }

                        // // tel
                        // if (!this.$store.state.register.form.tel) {
                        //     this.$store.state.register.errors.tel_required = true;
                        //     validate = false;
                        // } else {
                        //     const reg_tel = new RegExp(/^(0{1}\d{9,10})$/); //ハイフンなしで実装 ハイフンありの場合 /^0[789]0-[0-9]{4}-[0-9]{4}$/
                        //     const val_tel = reg_tel.test(this.$store.state.register.form.tel);
                        //     if (!val_tel) {
                        //         // 電話番号を入力していない場合
                        //         this.$store.state.register.errors.tel_required = false;
                        //         this.$store.state.register.errors.tel_error = true;
                        //         validate = false;
                        //     } else {
                        //         // OK
                        //         this.$store.state.register.errors.tel_required = false;
                        //         this.$store.state.register.errors.tel_error = false;
                        //     }
                        // }
                    }

                    if (url.indexOf( 'showroom' ) != -1) {
                        // sales_brands
                        // if (!this.$store.state.register.form.sales_brands || (this.$store.state.register.form.sales_brands && this.$store.state.register.form.sales_brands.length < 2)) {
                        //     this.$store.state.register.form.sales_brands.length;
                        //     this.$store.state.register.errors.sales_brands = true;
                        //     validate = false;
                        // } else {
                        //     this.$store.state.register.errors.sales_brands = false;
                        // }
                        // // other_brand
                        // if (!this.$store.state.register.form.other_brand) {
                        //     this.$store.state.register.errors.other_brand = true;
                        //     validate = false;
                        // } else {
                        //     this.$store.state.register.errors.other_brand = false;
                        // }
                    }
                }

                if (!validate) {
                    this.openAlertModal('error', 'エラー', '必須項目を入力してください。'); //確認済み
                } else {
                    //プレビューボタンを非表示
                    $('.btn_examination-wrap._preview').removeClass('_show');
                    //エディットセクションを非表示
                    $('.dply_detail-page ._edit-section .section-inner').addClass('_fade-out');
                    setTimeout(() => {
                        //審査するボタンを表示
                        $('.btn_examination-wrap._next').addClass('_show');
                        //エディットセクションを非表示
                        $('.dply_detail-page ._edit-section').addClass('_none');
                        //プレビューセクションを表示
                        $('.dply_detail-page ._preview-section').addClass('_block');
                        //プレビュー表示ラベルを表示
                        $('.preview-label-wrap').addClass('_show');

                        this.pageScrollTop();
                    }, 500);
                    setTimeout(() => {
                        //プレビューセクションを表示
                        $('.dply_detail-page ._preview-section .section-inner').addClass('_fade-in');

                        this.pageScrollTop();
                    }, 550);
                }
            },
            previewBack: function () {
                this.previewBtn = true;
                this.show_preview = false;

                //審査するボタンを非表示
                $('.btn_examination-wrap._next').removeClass('_show');
                //プレビューセクションを非表示
                $('.dply_detail-page ._preview-section .section-inner').removeClass('_fade-in');
                setTimeout(() => {
                    //プレビューボタンを表示
                    $('.btn_examination-wrap._preview').addClass('_show');
                    //プレビューセクションを表示
                    $('.dply_detail-page ._preview-section').removeClass('_block');
                    //エディットセクションを非表示
                    $('.dply_detail-page ._edit-section').removeClass('_none');
                    //プレビュー表示ラベルを非表示
                    $('.preview-label-wrap').removeClass('_show');
                }, 500);
                setTimeout(() => {
                    //エディットセクションを表示
                    $('.dply_detail-page ._edit-section .section-inner').removeClass('_fade-out');
                }, 550);
            },
            backList: function () {
                //Inertiaだと編集後の時のみエラーが出る 一旦location.hrefにしている
                if (location.pathname.indexOf( '/demo' ) != -1) {
                    if (location.pathname.indexOf( 'brand' ) != -1) {
                        var url = '/admin/brand/operation';
                        // var url = 'admin.brand.list';
                    } else if (location.pathname.indexOf( 'shop' ) != -1) {
                        var url = '/admin/shop/operation';
                        // var url = 'admin.shop.list';
                    } else if (location.pathname.indexOf( 'showroom' ) != -1) {
                        var url = '/admin/showroom/operation';
                        // var url = 'admin.shop.list';
                    }
                } else {
                    if (location.pathname.indexOf( 'brand' ) != -1) {
                        var url = '/admin/brand';
                        // var url = 'admin.brand.list';
                    } else if (location.pathname.indexOf( 'shop' ) != -1) {
                        var url = '/admin/shop';
                        // var url = 'admin.shop.list';
                    } else if (location.pathname.indexOf( 'showroom' ) != -1) {
                        var url = '/admin/showroom';
                        // var url = 'admin.shop.list';
                    }
                }

                location.href= url;
                // Inertia.get(route(url))
            },
            pageScrollTop: function() {
                window.scroll({
                    top: 0,
                    behavior: "smooth",
                });
            },
            getTOP: function () {
                var url = '/';
                location.href= url;
            },
            showToast(value) {
                this.toastFor = value;
            },
            showConfirmPriceZone() {
                var id = '';
                var type = '';
                var demo = false;
                var url = location.pathname;
                if (this.brand || this.shop) {
                    if (url.indexOf( 'brand' ) != -1) {
                        id = this.brand.id;
                    } else if (url.indexOf( 'shop' ) != -1) {
                        id = this.shop.id;
                    } else if (url.indexOf( 'showroom' ) != -1) {
                        id = this.brand.id;
                    }
                }
                if (url.indexOf( 'brand' ) != -1) {
                    type = 1;
                } else if (url.indexOf( 'shop' ) != -1) {
                    type = 0;
                } else if (url.indexOf( 'showroom' ) != -1) {
                    type = 2;
                }

                if (url.indexOf( '/demo' ) != -1) {
                    demo = true;
                }

                const form = reactive({
                    id: id,
                    type: type,
                    demo: demo,
                    form: this.$store.state.register.form,
                });
                Inertia.post(route('registration.examination'), form, {
                    preserveScroll: true,
                    onError: (errors) => {
                        this.openAlertModal('error', 'エラー', errors.name); // 確認済み
                        setTimeout(() => { this.backPriceZone(); }, 2000); // modalを見る時間確保
                    },
                    onSuccess: visit => {
                        this.show_confirm_price_zone = true;
                        $('.btn_examination-wrap').removeClass('_show');
                        $('.dply_detail-page').removeClass('_show');
                        $('.preview-label-wrap').removeClass('_show');
                        setTimeout(() => {
                            $('.dply_detail-page').removeClass('_block');
                            $('.examination-completion').addClass('_block');
                        }, 800);
                        setTimeout(() => {
                            $('.examination-completion').addClass('_show');
                        }, 850);
                    },
                })
            },
            backPriceZone() {
                //Swiperをフェードアウト
                $('.swiper-container').addClass('_hidden');
                setTimeout(() => {
                    //Swiperをdisplay:none;
                    $('.swiper-container').addClass('_none');
                    this.showPriceZone = false;
                }, 200);
                setTimeout(() => {
                    //確認画面のdisplay:none;を解除
                    $('.dply_detail-page').addClass('_block');
                }, 200);
                setTimeout(() => {
                    //確認画面をフェードイン
                    $('.dply_detail-page').addClass('_show');
                    //審査するボタンを表示
                    $('.btn_examination-wrap').addClass('_show');
                    $('.preview-label-wrap').addClass('_show');
                    //プレビューボタンを非表示
                    $('.btn_examination-wrap._preview').removeClass('_show');
                }, 250);
            },
            openCropper() {
                this.previewBtn = false;
            },
            closeCropper() {
                this.previewBtn = true;
                setTimeout(() => {
                    //プレビューボタンを表示
                    $('.btn_examination-wrap._preview').addClass('_show');
                }, 500);
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';
            },
            setData() {
                if (this.result) {
                    this.$store.state.register.set.sales_recruitment = this.result.sales_recruitment;
                    this.$store.state.register.set.categories = this.result.categories;
                    this.$store.state.register.set.sales_style = this.result.sales_style;
                    this.$store.state.register.set.order = this.result.order;
                    this.$store.state.register.set.pay_rule = this.result.pay_rule;
                    this.$store.state.register.set.categories = this.result.categories;
                    this.$store.state.register.set.areas = this.result.areas;
                    this.$store.state.register.set.area_prefectures = this.result.area_prefectures;
                    this.$store.state.register.set.brands = this.result.brands;
                    this.$store.state.register.set.sales_brands = this.result.sales_brands;
                }
                if (this.signup_token) {
                    this.$store.state.register.form.token_id = this.signup_token.id;
                    this.$store.state.register.form.company_name = this.signup_token.company_name;
                    this.$store.state.register.form.company_phonetic = this.signup_token.company_phonetic;
                    this.$store.state.register.form.company_post_code = this.signup_token.company_post_code;
                    this.$store.state.register.form.company_address = this.signup_token.company_address;
                    this.$store.state.register.form.company_tel = this.signup_token.company_tel;
                    // this.$store.state.register.form.company_kind = this.signup_token.company_kind;
                    this.$store.state.register.form.invitation_email = this.signup_token.invitation_email;
                    this.$store.state.register.form.company_type = this.signup_token.company_type;
                    this.$store.state.register.form.registration_plan = this.signup_token.registration_plan;
                }
                // 編集の時はthis.brandがある。なければ新規追加
                if (this.brand) {
                    this.$store.state.detail.set.brand = this.brand;
                    if (this.$store.state.detail.set.brand.plan == 1 && (this.$store.state.detail.set.brand.subscription_status == 'active' || this.$store.state.detail.set.brand.subscription_status == 'onGracePeriod')) {
                        this.$store.state.detail.set.activeBasicBrand = true;
                    }
                }
                if (this.shop) {
                    this.$store.state.detail.set.brand = this.shop;
                }
                if (this.shops) {
                    this.$store.state.detail.set.modal_list = this.shops;
                }
                if (this.like) {
                    this.$store.state.detail.set.like = this.like;
                }
                if (this.subscription_count) {
                    this.$store.state.detail.set.subscription_count = this.subscription_count;
                }
                // 未ログインの場合はローカルストレージを確認
                if (!this.user && this.brand && this.brand.id) {
                    this.like.status = likeMixins.methods.isLike(this.brand.id);
                }
                if (this.user) {
                    this.$store.state.detail.set.user = this.user;
                    if (this.brand) {
                        // 運営でログイン時に閲覧しているブランドのプランとプランの課金状態による表示の条件分岐に使用する値をセット
                        if (this.user.type == 0 && this.brand.plan == 1 && (this.$store.state.detail.set.brand.subscription_status == 'active' || this.$store.state.detail.set.brand.subscription_status == 'onGracePeriod')) {
                            this.$store.state.detail.set.adminAndBasic = true;
                        }
                    }
                }
                // 閲覧側および閲覧される側のプランとプランの課金状態による表示の条件分岐に使用する値をセット
                if (this.shopUserPlan && this.brand.subscription_status) {
                    if (this.shopUserPlan == 10 && this.brand.plan == 1 && (this.$store.state.detail.set.brand.subscription_status == 'active' || this.$store.state.detail.set.brand.subscription_status == 'onGracePeriod')) {
                        this.$store.state.detail.set.personalAndBasic = true;
                    } else if (this.shopUserPlan == 11 && this.brand.plan == 1 && (this.$store.state.detail.set.brand.subscription_status == 'active' || this.$store.state.detail.set.brand.subscription_status == 'onGracePeriod')) {
                        this.$store.state.detail.set.unitAndBasic = true;
                    }

                    // 閲覧側がショップのプラン personal or unit  表示側がショールーム有料の場合
                    if (this.shopUserPlan == 10 && this.showShowRoom) {
                        this.$store.state.detail.set.personalAndShowRoom = true;
                    } else if (this.shopUserPlan == 11 && this.showShowRoom) {
                        this.$store.state.detail.set.unitAndShowRoom = true;
                    }

                    if (this.user.type == 2 && this.shopUserPlan == 1 && this.showShowRoom && this.brand.type == 2 && this.brand.plan == 1) {
                        // 閲覧側がブランド有料プラン  表示側がショールーム有料の場合
                        this.$store.state.detail.set.basicAndShowRoom = true;
                    } else if (this.user.type == 2 && this.user.company_id == this.brand.company_id && this.shopUserPlan == 1 && this.brand.type == 1 && this.brand.plan == 1) {
                        // 閲覧側がブランド有料プラン  表示側が自社のブランド有料の場合
                        this.$store.state.detail.set.unitAndBasic = true;
                    } else if (this.user.type == 3 && this.shopUserPlan == 1 && this.brand.type == 1 && this.brand.plan == 1) {
                        // 閲覧側がショールーム有料プラン  表示側がブランド有料の場合
                        this.$store.state.detail.set.showRoomAndBasic = true;
                    } else if (this.user.type == 3 && this.user.company_id == this.brand.company_id && this.shopUserPlan == 1 && this.brand.type == 2 && this.brand.plan == 1) {
                        // 閲覧側がショールーム有料プラン  表示側が自社のショールーム有料の場合
                        this.$store.state.detail.set.unitAndShowRoom = true;
                    }
                }

                var url = location.pathname;

                // デモページの時はフルページで表示する
                if (url.indexOf( '/demo/' ) != -1) {
                    if (url.indexOf( 'brand' ) != -1) {
                        this.$store.state.detail.set.showRoomAndBasic = true;
                        this.$store.state.detail.set.activeBasicBrand = true;
                    } else if (url.indexOf( 'showroom' ) != -1) {
                        this.$store.state.detail.set.basicAndShowRoom = true;
                    }
                }

                if (url.indexOf( 'registration' ) != -1) {
                    if (url.indexOf( 'showroom' ) != -1) {
                        this.$store.state.detail.set.basicAndShowRoom = true;
                    }
                }

                if (url.indexOf( 'registration' ) == -1) {
                    if (url.indexOf( 'brand/detail' ) != -1 || url.indexOf( 'shop/detail' ) != -1 || url.indexOf( 'showroom/detail' ) != -1) {
                        //管理画面での編集
                        if (this.user.type == 0) {
                            if (url.indexOf( '/demo' ) != -1) {
                                this.confirmIn();
                            } else {
                                // 運営が詳細編集ページを開いた時のみプレビュー表示
                                this.previewBtn = false;
                                this.show_preview = true;
                                this.confirmIn();
                                this.previewIn();
                            }
                        } else {
                            this.confirmIn();
                        }
                    } else {
                        //エンドユーザー側での表示
                        this.show_preview = true;
                        this.confirmIn();
                        this.previewIn();
                    }
                }

                // エンドユーザー用の用の表示の場合 閲覧者がログインしているか
                if ((url.indexOf( 'brand-detail' ) !== -1 || url.indexOf( 'showroom-detail' ) !== -1) && !this.user) {
                    this.$store.state.detail.set.isUserToEnd = false;
                }
            }
        },
        created() {
            if (this.pageType != 2) {
                window.addEventListener('beforeunload', function(e) {
                    e.preventDefault();
                    e.returnValue = '他のページに移動しますか？';
                });
            }
            window.addEventListener('pageshow',()=>{
                if(window.performance.navigation.type==2) location.reload();
            });
            this.setData();
        },
        mounted() {
            if (!this.user && !this.isDemo) {
                this.modalShowForTargetClass('_register-promotion');
            }
        },
        computed: {
            pageType() {
                var url = location.pathname;
                if (url.indexOf( 'registration' ) != -1) {
                    //初回編集
                    return 0;
                } else if (url.indexOf( '/detail' ) != -1) {
                    if (this.brand || this.shop) {
                        //管理画面での編集
                        return 1;
                    } else {
                        //管理画面での新規追加
                        return 3;
                    }
                } else {
                    //エンドユーザー側での表示
                    return 2;
                }
            },
            showShowRoom() {
                var url = location.pathname;
                return url.indexOf( '/showroom' ) != -1;
            },
            showDemo() {
                var url = location.pathname;
                return url.indexOf( '/demo' ) != -1;
            },
        }
    };
</script>
